import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { AuthContext } from '../../../contexts/AuthContext';
import "../assets/css/feathericon.min.css"

const SideNav = (props) => {

    const history = useHistory();
    const { resetUserState } = useContext(AuthContext);

    const logouthandler = () => {
        resetUserState();
        history.push('/');
    };

    return (
        <div className="profile-sidebar">
            <div className="dashboard-widget">
                <nav className="dashboard-menu">
                    <ul>
                        <li className={props.applyCssFor === 'admindashboard' ? 'active' : ''}>
                            <a href="#/admindashboard">
                                <i className="fe fe-home"></i>
                                <span>Dashboard</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'appoinments' ? 'active' : ''}>
                            <a href="#/appoinments">
                                <i className="fe fe-layout"></i>
                                <span>Appointments</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'specialities' ? 'active' : ''}>
                            <a href="#/specialities">
                                <i className="fe fe-users"></i>
                                <span>Specialities</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'doctors' ? 'active' : ''}>
                            <a href="#/doctors">
                                <i className="fe fe-user-plus"></i>
                                <span>Doctors</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'patients' ? 'active' : ''}>
                            <a href="#/patients">
                                <i className="fe fe-user"></i>
                                <span>Patients</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'reviews' ? 'active' : ''}>
                            <a href="#/reviews">
                                <i className="fe fe-star"></i>
                                <span>Reviews</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'transactions' ? 'active' : ''}>
                            <a href="#/transactions">
                                <i className="fe fe-activity"></i>
                                <span>Transactions</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'settings' ? 'active' : ''}>
                            <a href="#/settings">
                                <i className="fe fe-vector"></i>
                                <span>Settings</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'invoicereport' ? 'active' : ''}>
                            <a href="#/invoicereport">
                                <i className="fe fe-document"></i>
                                <span>Invoice Reports</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'Inventory' ? 'active' : ''}>
                            <a href="#/inventory">
                                <i className="fas fa-warehouse"></i>
                                <span>Inventory</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'service' ? 'active' : ''}>
                            <a href="#/service">
                                <i className="fas fa-building"></i>
                                <span>Service</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'changepassword' ? 'active' : ''}>
                            <a href="#/changepassword">
                                <i className="fas fa-lock"></i>
                                <span>Change Password</span>
                            </a>
                        </li>
                        <li>
                            <Link onClick={logouthandler}>
                                <i className="fas fa-sign-out-alt"></i>
                                <span>Logout</span>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default SideNav;